import { render } from "./MovePointModal.vue?vue&type=template&id=d31e372e&scoped=true"
import script from "./MovePointModal.vue?vue&type=script&lang=js"
export * from "./MovePointModal.vue?vue&type=script&lang=js"

import "./MovePointModal.vue?vue&type=style&index=0&id=d31e372e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31e372e"]])

export default __exports__